import NP from 'number-precision'

const CHARGE_UNIT_TON = { us: 'TON', ch: '吨' }
const CHARGE_UNIT_KG = { us: 'KG', ch: '千克' }
const CHARGE_UNIT_SHEET = { us: 'SHEET', ch: '张' }
const CHARGE_UNIT_ROOT = { us: 'ROOT', ch: '根' }
const CHARGE_UNIT_PIECE = { us: 'PIECE', ch: '件' }
const CHARGE_UNIT_AN = { us: 'AN', ch: '个' }

const CHARGE_UNIT_LIST = [
  CHARGE_UNIT_SHEET.ch,
  CHARGE_UNIT_ROOT.ch,
  CHARGE_UNIT_PIECE.ch,
  CHARGE_UNIT_AN.ch
]

/**
 * 计算价格
 *
 * @param chargeUnit 计价单位
 * @param quantity 数量
 * @param weight 重量-TON吨
 * @param perAmount 单价
 * @return 金额-分
 */
function calculateWithUnit(chargeUnit, quantity, weight, perAmount) {
  if (!chargeUnit) throw new Error('chargeUnit is empty')
  let money = 0
  if (CHARGE_UNIT_LIST.indexOf(chargeUnit) != -1) {
    money = NP.times(quantity, perAmount)
  } else if (CHARGE_UNIT_TON.ch === chargeUnit) {
    money = NP.times(weight, perAmount)
  } else if (CHARGE_UNIT_KG.ch === chargeUnit) {
    money = NP.times(weight, 1000, perAmount)
  }
  return money
}

export { calculateWithUnit }
